import React from 'react';
import { Helmet } from 'react-helmet';

export const PatientFormsTitleInjection: React.FunctionComponent<{
  children: string | JSX.Element | JSX.Element[] | (() => JSX.Element);
}> = ({ children }) => (
  <>
    <Helmet>
      <title>Patient Forms</title>
    </Helmet>
    {children}
  </>
);
